import $ from 'jquery';

export const init = () => {

	var btn_loading = false;

	$(document)
		.on('click', '.js-print', function(e) {
			e.preventDefault();

			window.print();
		})
		.on('click', '.js-toggle-terms', function(e){
			e.preventDefault();

			var $terms = $('#toggle-terms');
			$terms.toggleClass('u-js-hide');
		})
		.on('click', 'a.load-articles-button', function(e) {
			if ( btn_loading === false ) {
				// zneaktivnime tlacitko
				btn_loading = true;

				// URL adresa, kterou pak nastavime
				var href = $(this).attr('href');

				// nastaveni promenne $(this)
				var this_el = $(this);

				// loading text + zachovani sirky tlacitka
				$(this).width($(this).width());
				$(this).find('span').text( 'Načítám...' );

				// ajax pozadavek na nacteni clanku
				$.ajax({
					method: 'POST',
					url: skwp.articles_api_url,
					data: {
						category: $(this).data('category'),
						paged: $(this).data('paged'),
						phase: $(this).data('phase'),
						ajax: 1
					},
					dataType: 'html'
				})
				.done(function(data) {
					// pridamy clanky do vypisu
					$('#articles-area').append(data);

					// zmenime URL
					window.history.pushState( { "html": data, "pageTitle": document.title }, "", href );

					// povolime scrolling a klikani na tlacitko
					ajax_loading_next = false;
					btn_loading = false;

					// zmena fungovani tlacitka
					if ( this_el.data('paged') >= this_el.data('max-pages') ) {
						$('#articles-pagination').hide();
					} else {
						var new_page = this_el.data('paged') + 1;
						var new_href = this_el.attr('href').replace('/' + this_el.data('paged') + '/', '/' + new_page + '/');
						this_el.data('paged', new_page).attr('href', new_href);
						this_el.css('width', 'auto');
						this_el.find('span').text('Načíst další');
					}
				});
			}

			e.preventDefault();
		});

	var ajax_loading_next = false;

	$(window)
		.on('resize scroll', function() {
			if ( !ajax_loading_next && $('#articles-pagination').length > 0 && $('#articles-pagination').css('display') != 'none' ) {
				var elementTop = $('#articles-pagination').offset().top;
				var elementBottom = elementTop + $('#articles-pagination').outerHeight();
				var viewportTop = $(window).scrollTop();
				var viewportBottom = viewportTop + $(window).height();

				if ( elementBottom > viewportTop && elementTop < viewportBottom ) {
					ajax_loading_next = true;
					$('a.load-articles-button').click();
				}
			}
		});

};



// WEBPACK FOOTER //
// ./src/js/components/eventActions.js